import Page from "webPage/Page";
import handleFilterModal from "../util/handleFilterModal";

Page.register('category', () => {
    handleFilterModal();
});
